import cn from 'classnames';
import { InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  label?: string;
}
export default forwardRef<HTMLInputElement, InputProps>(function Input({ label, error, className, ...props }, ref) {
  const disabledClasses = 'disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-600';
  const readonlyClasses = 'readonly:cursor-not-allowed readonly:bg-gray-200 readonly:text-gray-600';
  return (
    <div className="relative">
      {label && (
        <label className="absolute -top-2 left-3 bg-white px-1 text-sm text-xs text-premium-dark dark:bg-premium-darker dark:text-white">
          {label}
        </label>
      )}
      <input
        {...props}
        ref={ref}
        className={cn(
          'dark:border-gray-350 w-full rounded-md border-2 border-premium-dark border-opacity-60 bg-white bg-white px-4 py-2 text-black outline-none placeholder:text-sm placeholder:text-gray-500 focus:border-premium-500 dark:border-gray-650 dark:bg-premium-darker dark:text-white',
          disabledClasses,
          readonlyClasses,
          { 'border-red-500 dark:border-red-500': error },
          className,
        )}
      />
    </div>
  );
});
